import React from "react";
import "./Hero.css";
import { useNavigate } from "react-router-dom";
export default function Hero() {
  const navigate = useNavigate();
  return (
    <section className="hero" id="hero">
      {/* ✅ Overlay for better contrast */}
      <div className="hero-overlay"></div>
      <div className="hero-content">
        <h1>Pakistan’s Favourite Shades of Trust</h1>
        <button className="cta-btn" onClick={() => navigate("/e-store")}>
          BUY YOUR FAVOURITE PAINTS NOW!
        </button>
      </div>
    </section>
  );
}
